<template lang="pug">
page-template.page-products.pb-16(:title="title", fluid)
  template(v-if="!loading")
    template(v-if="items.length")
      grid-list.page-products-list.justify-center.px-md-10(
        col-width="min(auto, 370px)",
        col-width-sm="370px"
      )
        product-card(
          v-for="({ img, title, to, category }, i) in items",
          :key="i",
          :img="img",
          :title="title",
          :category="category.title",
          :to="to"
        )
    .d-flex.justify-center(v-else)
      v-alert.mx-auto(type="info", color="secondary") Nenhuma máquina disponível.
  .py-10.d-flex.justify-center(v-else)
    v-progress-circular(size="50", color="primary", indeterminate)
</template>

<script>
import PageTemplate from "@/components/templates/Page.vue";
import CustomTitle from "@/components/shell/CustomTitle.vue";
import ProductCard from "@/components/cards/Product";
import { formatToURL } from "@/components/utils";

const _config = {
  mod: "products",
  path: "/maquinas",
  title: "Máquinas",
};

export default {
  data: () => ({
    loading: true,
    title: _config.title,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list.map(
        ({ id, img, title, category }) => ({
          img: img ? this.files + img : "",
          title,
          category,
          to: `${_config.path}/${formatToURL(`${title}-${id}`)}`,
        })
      );
    },
    sm() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  beforeCreate() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  components: {
    PageTemplate,
    CustomTitle,
    ProductCard,
  },
};
</script>

<style>
.page-products-list {
  gap: 30px !important;
}
</style>